import { render } from "./SelecionarRelacaoPessoa.vue?vue&type=template&id=6e3a723c&ts=true"
import script from "./SelecionarRelacaoPessoa.vue?vue&type=script&lang=ts"
export * from "./SelecionarRelacaoPessoa.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__